import * as Sentry from '@sentry/react';
import { createRouter } from '@tanstack/react-router';
import ErrorComponent from '@/components/ErrorComponent';
import NotFoundComponent from '@/components/NotFoundComponent';
import { store } from '@/store';
import { routeTree } from '../routeTree.gen';

export const router = createRouter({
  routeTree,
  context: { store },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
  defaultErrorComponent: ErrorComponent,
  defaultNotFoundComponent: NotFoundComponent,
  defaultOnCatch: (error, info) => {
    Sentry.captureReactException(error, info);
  },
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

export type AppRouter = typeof router;
